import {
  BookOpen, CalendarRange, HeartHandshake, SlidersHorizontal, PenLine,
  Palette, ClipboardList, Bus, NotebookPen,
} from "lucide-react";

export const DOC_TYPES = [
  {
    id: "priprema",
    label: "Priprema za sat",
    short: "Dnevna priprema za nastavni sat",
    icon: BookOpen,
    needsSubject: true,
    needsLevelGrade: true,
    needsLesson: true,
    needsStudent: false,
  },
  {
    id: "gik",
    label: "GIK",
    short: "Godišnji izvedbeni kurikulum",
    icon: CalendarRange,
    needsSubject: true,
    needsLevelGrade: true,
    needsLesson: false,
    needsStudent: false,
    hasGikMode: true,
  },
  {
    id: "ioop",
    label: "Individualizirani kurikulum (IK)",
    short: "Individualizirani kurikulum za učenika s teškoćama",
    icon: HeartHandshake,
    needsSubject: true,
    needsLevelGrade: true,
    needsLesson: false,
    needsStudent: true,
  },
  {
    id: "prilagodeni_gik",
    label: "Prilagođeni GIK",
    short: "GIK za učenike s prilagođenim programom",
    icon: SlidersHorizontal,
    needsSubject: true,
    needsLevelGrade: true,
    needsLesson: false,
    needsStudent: true,
    hasGikMode: true,
  },
  {
    id: "ina",
    label: "Plan i program INA",
    short: "Izvannastavna aktivnost (dramska, sportska, novinarska...)",
    icon: Palette,
    needsSubject: false,
    needsLevelGrade: false,
    needsLesson: false,
    needsStudent: false,
  },
  {
    id: "gpp_razrednika",
    label: "GPP razrednika",
    short: "Godišnji plan rada razrednika i sat razrednika",
    icon: ClipboardList,
    needsSubject: false,
    needsLevelGrade: true,
    needsLesson: false,
    needsStudent: false,
  },
  {
    id: "izvanucionicka",
    label: "Izvanučionička nastava",
    short: "Plan terenske nastave, izleta ili ekskurzije",
    icon: Bus,
    needsSubject: false,
    needsLevelGrade: true,
    needsLesson: false,
    needsStudent: false,
  },
  {
    id: "zapisnik_roditeljski",
    label: "Zapisnik s roditeljskog",
    short: "Zapisnik roditeljskog sastanka",
    icon: NotebookPen,
    needsSubject: false,
    needsLevelGrade: true,
    needsLesson: false,
    needsStudent: false,
  },
  {
    id: "vlastiti",
    label: "Vlastiti dokument",
    short: "Bilo koji drugi školski dokument",
    icon: PenLine,
    needsSubject: false,
    needsLevelGrade: false,
    needsLesson: false,
    needsStudent: false,
  },
];
